import Data from '@/models/data';
import Template from '@/models/template';
import TemplateSelection from '@/models/templateSelection';
import httpClient from '@/services/httpClient';
import { Action, getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import store from '../index';
import { names } from './index';

@Module({
    dynamic: true,
    namespaced: true,
    name: names.Templates,
    store,
})
class TemplatesModule extends VuexModule {
    public templates: Data<Template[]> = Data.success([]);
    public selectedTemplate: TemplateSelection | null = null;

    @Mutation
    public setSelectedTemplate(template: TemplateSelection | null) {
        this.selectedTemplate = template;
    }

    @Action
    public async updateTemplates() {
        this.setTemplates(Data.loading());
        try {
            const data = await httpClient.get('templates').then((r) => r.data);
            this.setTemplates(Data.success(data.templates));
        } catch (error) {
            this.setTemplates(Data.error(error));
        }
    }

    @Mutation
    private setTemplates(templates: Data<Template[]>) {
        this.templates = templates;
    }
}

export default getModule(TemplatesModule);
